export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/product_research_methods_lingo-75903d5c6c2777ed15713bdba59fc665.png";